import instance from "./api";
import EndPoints from "./api-endpoints";

//Add login api

const login = async (email: string, password: string) => {
  try {
    const loginObj = {
      AuthParameters: {
        USERNAME: email,
        PASSWORD: password,
      },
      AuthFlow: "USER_PASSWORD_AUTH",
      ClientId: "2q8vca4hfe4nt2s694kdt0u0o5",
    };

    return instance
      .post(EndPoints.cognitoLogin, loginObj, {
        headers: {
          "Content-Type": "application/x-amz-json-1.1",
          "X-Amz-Target": "AWSCognitoIdentityProviderService.InitiateAuth",
          "X-Amz-User-Agent": "aws-amplify/0.1.x",
        },
      })
      .then((response) => response)
      .catch((error) => error.response);
  } catch (error) {
    return error;
  }
};

const getUser = async (idToken: string) => {
  return instance
    .get(EndPoints.getUser, {
      headers: {
        IdToken: idToken,
      },
    })
    .then((response) => response)
    .catch((error) => error.response);
};

//Add otp verification api
const otpVerification = async (
  email: string,
  otp: string,
  session: string | undefined
) => {
  try {
    const otpVerificationObj = {
      email,
      otp,
      session: session,
    };

    return instance
      .post(EndPoints.otp, otpVerificationObj)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error.response;
      });
  } catch (error) {
    return error;
  }
};

export { login, getUser, otpVerification };
